/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { tryParseJson } from 'src/core/utils/base';
import { getStorage } from 'src/core/utils/getStorage';
import { LuisConstants } from 'src/core/utils/LuisConstants';
import { DTPageName } from 'src/core/utils/telemetryUtils';
import { TranslationFileSourceOptions, TranslationInfoDto } from 'src/translation/components/TranslationCreationPage';

const initTranslationInfoDto = (autoDetectMessage: string, translatorStorageAccount: string): TranslationInfoDto => ({
    filesSelected: [],
    glossaryFiles: [],
    targetLanguages: [],
    selectedBlobFiles: [],
    destinationFolder: '',
    selectedLocalFiles: [],
    sourceContainerName: '',
    isUploadToBlobStore: false,
    customTranslatorModelId: '',
    isContainerSelectAll: false,
    destinationContainerName: null,
    isDownloadToLocalStorage: false,
    uploadContainerName: LuisConstants.TranslationTool.AutoGeneratedContainerName,
    storageAccount: translatorStorageAccount,
    filesLocation: TranslationFileSourceOptions.LocalStorage,
    sourceLanguage: {
        key: LuisConstants.TranslationTool.AutoLanguageDetectionItemKey,
        value: autoDetectMessage
    }
});

export const removeDtoFromStorage = () =>
    getStorage('sessionStorage').removeData(LuisConstants.StorageKeys.TranslationJobCreationDataStorageKey);

const isDtoSavedInStorage = () => getStorage('sessionStorage').hasData(LuisConstants.StorageKeys.TranslationJobCreationDataStorageKey);

export const getDtoFromStorage = (autoDetectMessage: string, translatorStorageAccount: string): TranslationInfoDto => {
    let storageData: TranslationInfoDto;
    if (isDtoSavedInStorage()) {
        storageData = tryParseJson(getStorage('sessionStorage').getData(LuisConstants.StorageKeys.TranslationJobCreationDataStorageKey));
    } else {
        storageData = initTranslationInfoDto(autoDetectMessage, translatorStorageAccount);
    }
    return { ...storageData, selectedLocalFiles: [], selectedBlobFiles: [] };
};

export const saveTranslationJobDtoToStorage = (translationConfigsDto: TranslationInfoDto) => {
    getStorage('sessionStorage').setData(
        LuisConstants.StorageKeys.TranslationJobCreationDataStorageKey,
        JSON.stringify(translationConfigsDto)
    );
};

export const getTranslationPageName = (pathName: string): DTPageName => {
    const splittedPath = pathName.split('/');
    const pageName = splittedPath[splittedPath.length - 1];
    if (pageName === 'translation') {
        return 'jobCreation';
    }
    if (pageName === 'history') {
        return 'jobHistory';
    }
    return 'settings';
};
